import { useEffect, useRef } from 'react';
import { Map, Marker, useMap } from '@vis.gl/react-google-maps';
import { Bs11DeckGlOverlay, GEOSERVER_ROOT_URL, VotingPlacesLayer, VotingPlacesMarkerLayer, VpLayerCqlFilter } from './DeckGlOverlay';
import { ActiveVotingPlaceListener, SearchListener } from './MapInfluence';
import { useAppStateStore, useEventInfoStore, useLayerVisibilityStore, useVotingPlaceStore } from '../../store/layerStore';
import HighlightMapMarker from './HighlightMapMarker';
import Directions from './Directions';
import { BcpagListener, ByelectionVotingPlacesListener, InEdVotingPlacesListener, NearestVotingPlacesListener, ParameterPlaceIdListener, PlaceSearchListener, SearchLocationListener, VP_WAIT_TIME_URL } from '../../api/votingPlaces';
import { AppScopes, VPTypeCodes } from '../../util';
import { VotingPlace } from '../../model';
import axios from 'axios';
import VotingPlaceAdvancedMarkerLayer from './VotingPlaceAdvanceMarkerLayer';

const DEFAULT_CENTER = { lat: 53.7267, lng: -127.6476 };
const DEFAULT_ZOOM = 6; //4;

type SwNeBounds = {
    sw?: { lat?: number; lng?: number };
    ne?: { lat?: number; lng?: number };
};

function toLatLngBoundsLiteral(bounds: unknown): google.maps.LatLngBoundsLiteral | null {
    if (!bounds || typeof bounds !== 'object') return null;

    const candidate = bounds as Partial<google.maps.LatLngBoundsLiteral> & SwNeBounds;
    const hasLiteralFields =
        typeof candidate.north === 'number' &&
        typeof candidate.south === 'number' &&
        typeof candidate.east === 'number' &&
        typeof candidate.west === 'number';

    if (hasLiteralFields) {
        return {
            north: candidate.north as number,
            south: candidate.south as number,
            east: candidate.east as number,
            west: candidate.west as number,
        };
    }

    const hasSwNeFields =
        typeof candidate.sw?.lat === 'number' &&
        typeof candidate.sw?.lng === 'number' &&
        typeof candidate.ne?.lat === 'number' &&
        typeof candidate.ne?.lng === 'number';

    if (hasSwNeFields) {
        return {
            south: candidate.sw!.lat as number,
            west: candidate.sw!.lng as number,
            north: candidate.ne!.lat as number,
            east: candidate.ne!.lng as number,
        };
    }

    return null;
}

function ByelectionMapBoundsListener() {
    const map = useMap();
    const { eventInfo } = useEventInfoStore();
    const lastAppliedConfigId = useRef<string | null>(null);

    useEffect(() => {
        if (!map || !eventInfo) return;
        if (eventInfo.scope !== AppScopes.BYELECTION || !eventInfo.mapBounds) return;
        if (lastAppliedConfigId.current === eventInfo.configId) return;

        const normalizedBounds = toLatLngBoundsLiteral(eventInfo.mapBounds);
        if (!normalizedBounds) return;

        map.fitBounds(normalizedBounds);
        lastAppliedConfigId.current = eventInfo.configId;
    }, [map, eventInfo]);

    return null;
}

export default function GoogleMapsContainer(props:any) {
    const { userLocation, searchPlace, lastSelectedPlace } = useAppStateStore();
    const hasActiveSearchSelection = !!searchPlace;
    
    const { setActiveVotingPlace } = useVotingPlaceStore();
    const { voterElectoralDistrictInfo, userState } = useAppStateStore();
    const { eventInfo } = useEventInfoStore();

    // useEffect(() => {
    //     if (isInitialMount.current) {
    //         isInitialMount.current = false;
    //     }
    // });
    const mapStyleOptions = [
        {
            featureType: "poi",
            stylers: [{ visibility: "off" }],
        },
        {
            featureType: "transit",
            elementType: "labels.icon",
            stylers: [{ visibility: "on" }],
        },
    ]

    return (
    // <APIProvider apiKey={API_KEY}>
        <Map
            // mapId='ef2801b7b7cb9a36'
            zoom={ DEFAULT_ZOOM }
            center={ DEFAULT_CENTER }
            gestureHandling={'greedy'}
            disableDefaultUI={true}
            draggableCursor={'default'}
            zoomControl={true}
            style={{height: props.containerHeight, transition: 'height 0.1s' }}
            styles={mapStyleOptions}
            
        >
            {/* <ZoomPositionControl controlPosition={ControlPosition.RIGHT_BOTTOM} /> */}

            <Bs11DeckGlOverlay />
            <ByelectionMapBoundsListener />

            {/* <VotingPlacesLayer /> */}
            <VotingPlacesMarkerLayer />
            {/* <VotingPlaceAdvancedMarkerLayer /> */}
            <SearchListener />
            <ActiveVotingPlaceListener />
            <ByelectionVotingPlacesListener />
            <NearestVotingPlacesListener />
            <InEdVotingPlacesListener />
            <SearchLocationListener />
            <PlaceSearchListener />
            <BcpagListener />
            <ParameterPlaceIdListener />
            <HighlightMapMarker />
            {/* { marker && <MapMarker /> } */}
            {lastSelectedPlace?.geometry?.location &&
                <Marker position={{lat: lastSelectedPlace.geometry.location.lat(), lng: lastSelectedPlace.geometry.location.lng() }} />
            }
            {userLocation && !hasActiveSearchSelection &&
                <Marker position={{lat: userLocation.lat, lng: userLocation.lng }} />
            }
            <Directions />
        </Map>
    // </APIProvider>
)
};